export default __webpack_public_path__ + "static/media/variable.4917487b.svg";